import { createReduxAsyncThunk } from 'shared/utils';

import { stationsAPI } from 'entities/stations';

import { STATIONS_STATE } from '../../constants';

import { StationsState } from '../../types';

export const getStationsPriceReportSettings = createReduxAsyncThunk<
  StationsState['stationsPriceReportSettings']['data']
>(
  `${STATIONS_STATE}/getStationsPriceReportSettings`,
  async () => {
    const { data } = await stationsAPI.getStationsPriceReportSettings();
    return data;
  }
);
